import { ROLES as R } from "../core/roles";
import { lud, only, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

// The page itself (`view`) is role-only. Every action is bound to the restaurant
// it targets (NA-011): the public id (`restaurant.id`, `request.storeCode`) the
// overview returned. Display code uses `has()`, handlers use `can(id, { restaurantId })`.
const restaurantScoped = (roles) => rule(roles, { scope: SCOPES.RESTAURANT });

export const ludConnectPermissions = {
  view: "ludConnect.view",
  manage: "ludConnect.manage",
  restaurantStatusEdit: "ludConnect.restaurant.status.edit",
  document: { download: "ludConnect.document.download" },
  provider: { act: "ludConnect.provider.act" },
  lud: { act: "ludConnect.lud.act" },
};

export const ludConnectGrants = {
  "ludConnect.view": rule(lud(R.DMM, R.AM, R.MENU_SP, R.FEEDUS)),
  // connection status / menu portal actions are limited to ceo-level
  "ludConnect.manage": restaurantScoped(lud()),
  "ludConnect.restaurant.status.edit": restaurantScoped(lud(R.DMM)),
  // organization documents shown in the restaurant summary: same roles as the page
  "ludConnect.document.download": restaurantScoped(lud(R.DMM, R.AM, R.MENU_SP, R.FEEDUS)),
  // integration partner side of a request (fills credentials, confirms)
  "ludConnect.provider.act": restaurantScoped(only(R.FEEDUS)),
  // LUD side of a request (drafts, clarifications, confirmations)
  "ludConnect.lud.act": restaurantScoped(lud(R.DMM, R.AM, R.MENU_SP)),
};
